// extracted by mini-css-extract-plugin
export default {"container":"ModalTitle_container__ZfvRK","title":"ModalTitle_title__rxZjZ","actions":"ModalTitle_actions__A3bLI","action-btn":"ModalTitle_action-btn__CpH10"};